<template lang="pug">
  component(:is="currentComponent" v-if="(currentStep.question || {}).type" @answered="receiveAnswered")
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'Question',
  computed: {
    ...mapGetters(['currentStep'])
  },
  beforeMount() {
      this.currentComponent = () => import(`@/${this.currentStep.question.type}`)
  },
  watch: {
    currentStep: {
      handler(val) {        
        //this.show = val.check || false; }    
        this.currentComponent = () => import(`@/${this.currentStep.question.type}`)
      },
      deep: true
    }
  },
  data() {    
    return {      
      currentComponent: null
    }
  },
  methods:{
    receiveAnswered(event){
      this.$emit('answered',event);
    }
  }
}
</script>